export default __webpack_public_path__ + "static/media/download.b587f661.svg";